import { Controller } from '@hotwired/stimulus';

import Glide from '@glidejs/glide';

export default class extends Controller {
  connect() {
    if (document.querySelector('.glide')) this.#carousel();
  }

  #carousel() {
    new Glide('.glide', {
      breakpoints: {
        767: { perView: 1.1 },
        1023: { perView: 2.2 },
        9999: { perView: 3.1 },
      },

      perView: 1.1,
    }).mount();
  }
}
